import React, { useState, useEffect, useRef } from 'react';

const CookieConsentBanner = () => {
  const [mounted, setMounted] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const bannerRef = useRef(null);

  useEffect(() => {
    // Detect if page is being rendered by build-time prerenderer (Puppeteer / Headless Chrome)
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    const isPrerender = 
      typeof window !== 'undefined' && 
      (Boolean(window.__IS_PRERENDERING__) || 
       ua.includes('HeadlessChrome') || 
       ua.includes('Prerender'));

    console.log('[CookieConsent] isPrerender check:', isPrerender, 'userAgent:', navigator.userAgent);

    if (isPrerender) {
      return; // Do not display or mount banner during static build prerendering
    }

    setMounted(true);
    try {
      const consent = localStorage.getItem('cookie_consent');

      if (consent === 'granted') {
        if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
          window.gtag('consent', 'update', {
            'ad_storage': 'granted',
            'analytics_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted'
          });
        }
      } else if (!consent) {
        setIsVisible(true);
      }
    } catch (err) {
      console.error('Error reading cookie consent state:', err);
      setIsVisible(true);
    }
  }, []);

  const hideBanner = () => {
    setIsVisible(false);
    if (bannerRef.current) {
      bannerRef.current.style.display = 'none';
    }
  };

  const handleAccept = () => {
    console.log('[CookieConsent] Accept clicked');
    try {
      if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
          'ad_storage': 'granted',
          'analytics_storage': 'granted',
          'ad_user_data': 'granted',
          'ad_personalization': 'granted'
        });
        window.gtag('event', 'page_view', {
          page_title: document.title,
          page_location: window.location.href,
          page_path: window.location.pathname + window.location.search
        });
      }
    } catch (err) {
      console.error('Gtag consent update error:', err);
    }

    try {
      localStorage.setItem('cookie_consent', 'granted');
    } catch (err) {
      console.error('Error saving cookie consent to localStorage:', err);
    }

    hideBanner();
  };

  const handleReject = () => {
    console.log('[CookieConsent] Reject clicked');
    try {
      localStorage.setItem('cookie_consent', 'denied');
    } catch (err) {
      console.error('Error saving cookie consent to localStorage:', err);
    }

    hideBanner();
  };

  // Do not render if not mounted or not visible
  if (!mounted || !isVisible) return null;

  return (
    <div 
      id="cookie-consent-banner"
      ref={bannerRef}
      style={{ zIndex: 9999999, position: 'fixed' }}
      className="bottom-4 left-1/2 -translate-x-1/2 pointer-events-auto w-[calc(100%-2rem)] max-w-4xl bg-slate-900/95 backdrop-blur-md text-white border border-slate-700/80 rounded-2xl p-4 sm:p-5 shadow-2xl transition-all duration-300"
    >
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3 text-sm text-slate-300 leading-relaxed text-center sm:text-left">
          <span className="text-xl shrink-0">🍪</span>
          <p>
            We use cookies to understand site usage and improve your experience. Accept to help us track this.
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0 w-full sm:w-auto justify-end">
          <button
            type="button"
            onClick={handleReject}
            style={{ zIndex: 10000000, position: 'relative', cursor: 'pointer' }}
            className="flex-1 sm:flex-none px-4 py-2 text-xs font-semibold text-slate-300 hover:text-white bg-slate-800 hover:bg-slate-700 border border-slate-700 rounded-xl transition-all active:scale-95 pointer-events-auto"
          >
            Reject
          </button>
          <button
            type="button"
            onClick={handleAccept}
            style={{ zIndex: 10000000, position: 'relative', cursor: 'pointer' }}
            className="flex-1 sm:flex-none px-5 py-2 text-xs font-bold text-white bg-indigo-600 hover:bg-indigo-500 rounded-xl shadow-lg shadow-indigo-600/30 transition-all active:scale-95 pointer-events-auto"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
